import { DisplayRailwayCompany } from './createStationDisplayData';
import { DisplayArea } from '../../LocationModal/logics/createLocationDisplayData';
import { CompositeIdString } from './checkedStationStateReducer';
/**
 * 全ての駅をチェックし、選択済みの駅を見つけた場合、
 * それに紐づく以下の項目を選択済み状態にする。
 * 路線、都道府県、路線会社
 * またすべての駅がチェック済みならば、路線をチェック済みにする。
 *
 * 返却時に選択済路線、選択済都道府県、選択済地域、選択済路線会社、チェック済路線
 * 上記5つが更新される。
 * @param checkedStation string[]
 * @param checkedAllRoute string[]
 * @param railwayCompanies CompanyOfSearchModal[]
 * @param changedId
 * @returns
 */
export const updateSelectedAssociatedWithStation = (
  checkedStation: string[],
  checkedAllRoute: string[],
  railwayCompanies: DisplayRailwayCompany[],
  changedId?: string
) => {
  // 更新用の選択済み配列を用意する
  const selectedPref: string[] = [];
  const selectedRoute: CompositeIdString[] = [];
  const selectedRailwayCompany: CompositeIdString[] = [];
  // それぞれの企業から全駅をチェックする。
  for (let i = 0; i < railwayCompanies.length; i += 1) {
    const railwayCompany = railwayCompanies[i];
    for (let j = 0; j < railwayCompany.routeList.length; j += 1) {
      const route = railwayCompany.routeList[j];
      // 駅が全てチェックしてあれば、フラグをたてる変数
      let isStationAllChecked = true;
      // 今回チェックされたのが路線だったらチェックする為の変数
      const isChangedRouteId = route.id === changedId;
      for (let k = 0; k < route.stationList.length; k += 1) {
        const station = route.stationList[k];
        const isCheckedAdd = checkedStation.includes(station.id);

        // 選択されていれば会社、県、沿線を選択中にする
        if (isCheckedAdd) {
          const routePrefectureId: CompositeIdString = `${route.id}:${station.prefectureId}`;
          if (!selectedRoute.includes(routePrefectureId)) {
            selectedRoute.push(routePrefectureId);
          }
          const railwayCompanyPrefectureId: CompositeIdString = `${railwayCompany.id}:${station.prefectureId}`;
          if (!selectedRailwayCompany.includes(railwayCompanyPrefectureId)) {
            selectedRailwayCompany.push(railwayCompanyPrefectureId);
          }
          if (!selectedPref.includes(station.prefectureId)) {
            selectedPref.push(station.prefectureId);
          }
        } else {
          isStationAllChecked = false;
        }
      }
      // 路線下の駅が全てチェック済なら、路線をチェックする。
      if (isChangedRouteId) {
        const routeIdx = checkedAllRoute.indexOf(route.id);
        if (isStationAllChecked && routeIdx === -1) {
          checkedAllRoute.push(route.id);
        } else if (!isStationAllChecked && routeIdx > -1) {
          checkedAllRoute.splice(routeIdx, 1);
        }
      }
    }
  }
  return {
    selectedPref,
    selectedRailwayCompany,
    selectedRoute,
    checkedAllRoute,
  };
};

/**
 * 全都道府県をチェックし、
 * 地域毎に都道府県が1つでも選択してあれば、
 * その地域を選択済み状態にする。
 * 上記5つが更新される。
 * @param selectedPref string[]
 * @param areas AreaListOfSearchModal[]
 * @returns
 */
export const updateSelectedArea = (
  selectedPref: string[],
  areas: DisplayArea[]
) => {
  // 選択済み地域
  const selectedArea: string[] = [];
  // 都道府県が1つでも選択済であれば、地域も選択済にする。
  for (let i = 0; i < selectedPref.length; i += 1) {
    const prefId = selectedPref[i];
    for (let j = 0; j < areas.length; j += 1) {
      const area = areas[j];
      for (let k = 0; k < area.prefectureList.length; k += 1) {
        const pref = area.prefectureList[k];
        // 選択済みのエリアに紐づく都道府県IDと
        // 選択済み都道府県IDが一致した場合
        if (prefId === pref.id) {
          selectedArea.push(area.id);
        }
      }
    }
  }
  return selectedArea;
};
